import {
  reservationOn,
  SPOT_STATUSES,
  type DayMode,
  type MapReservation,
  type MapResponse,
  type MapSpot,
  type SpotStatus,
} from '@kratispot/shared';

export type StatusFilter = SpotStatus | 'all';

export type ListRow = {
  readonly spot: MapSpot;
  readonly booking: MapReservation | null;
  readonly guests: readonly string[];
};

// A past day has no status to filter by; a future one knows only two. §15
export function statusFiltersFor(mode: DayMode): StatusFilter[] {
  if (mode === 'past') return ['all'];
  if (mode === 'future') return ['all', 'free', 'reserved'];
  return ['all', ...SPOT_STATUSES];
}

export function guestsOf(spot: MapSpot): string[] {
  return spot.reservations.map((booking) => booking.guestName);
}

// Staff search by the number they can see, or the name they were told.
export function matchesQuery(spot: MapSpot, query: string): boolean {
  const needle = query.trim().toLowerCase();
  if (needle === '') return true;
  return `${spot.number} ${guestsOf(spot).join(' ')}`.toLowerCase().includes(needle);
}

export function listRows(map: MapResponse, query: string, filter: StatusFilter): ListRow[] {
  return map.spots
    .filter((spot) => (filter === 'all' ? true : spot.status === filter))
    .filter((spot) => matchesQuery(spot, query))
    .map((spot) => ({ spot, booking: reservationOn(spot), guests: guestsOf(spot) }));
}
